<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle" :bordered="false">
        <div class="media-page-header">
          <span class="media-page-title">素材管理</span>
          <span class="media-page-tip">统一维护图片素材，上传走主工程统一存储（OSS/本地自动切换），各业务页从素材库引用</span>
        </div>
        <!-- 管理模式网格：selectable=false，点击图片为预览大图 -->
        <media-grid @preview="onPreview" />
        <!-- 大图预览 -->
        <a-modal :visible="previewVisible" :footer="null" :width="860" title="图片预览" @cancel="previewVisible = false">
          <img :src="previewUrl" style="width: 100%" alt="图片预览" />
        </a-modal>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>
import { getFileAccessHttpUrl } from '@/api/manage'
import MediaGrid from './MediaGrid'
import { mixinDevice } from '@/utils/mixin'

/**
 * 素材管理页（系统管理菜单，url=/system/media，component=plugin/dining/media/MediaManage）
 * 整页容器内嵌 MediaGrid（管理模式）：点击缩略图预览大图；上传/分组/移动/回收站操作在 MediaGrid 内
 */
export default {
  name: 'MediaManage',
  mixins: [mixinDevice],
  components: { MediaGrid },
  data() {
    return {
      cardStyle: '',
      previewVisible: false,
      previewUrl: ''
    }
  },
  created() {
    if (this.isDesktop()) {
      this.cardStyle = 'height:' + (document.documentElement.clientHeight - 100) + 'px;overflow:auto'
    }
  },
  methods: {
    onPreview(item) {
      const path = (item && item.url) || ''
      if (!path) {
        return
      }
      this.previewUrl = path.indexOf('http') === 0 ? path : getFileAccessHttpUrl('systemConfig/static/' + path)
      this.previewVisible = true
    }
  }
}
</script>

<style scoped>
.media-page-header {
  display: flex;
  align-items: baseline;
  margin-bottom: 14px;
}
.media-page-title {
  font-size: 16px;
  font-weight: bold;
  margin-right: 12px;
}
.media-page-tip {
  color: #999;
  font-size: 12px;
}
</style>
